export default __webpack_public_path__ + "static/media/EmptyCartBox.4a82d8d8.svg";